import * as yup from 'yup';

export const userValidationSchema = yup.object({
  name: yup.string().required('A first and last name is required'),
  userGroupId: yup.string().required('You must select an organization'),
  email: yup.string().email('You must provide a valid email address').required('A valid email address is required'),
});

export const addFirmDialogValidationSchema = yup.object({
  firmId: yup.string().required('A firm is required'),
});

export const initialUserValues = { name: '', email: '', userGroupId: '', isDisabled: false, imageUrl: '' };

export const userGroupValidationSchema = yup.object({
  name: yup.string().required('An organization name is required'),
});

export const siteValidationSchema = yup.object({
  property: yup.string().required('A property name is required'),
  city: yup.string().required('A city is required'),
  url: yup.string().url('You must enter a valid URL').required('A URL is required'),
});

export const emailTemplateValidationSchema = yup.object({
  description: yup.string().required('A description is required'),
  template: yup.string().required('A template is required'),
});
